import dayjs, { type Dayjs } from '@/utilities/dayjs-config'
import { Subscription } from './subscription'

export class ProductSubscription extends Subscription {
  #currentShipmentDate?: Dayjs = undefined

  get hasRenewalDuringBlackFridayWeeks() {
    return true // TODO: implement
  }

  get currentShipmentDate() {
    if (this.#currentShipmentDate) return this.#currentShipmentDate

    const monthAfterStartDate = dayjs(this.startDate).add(1, 'month')

    // For preorders, make sure we return the start date if it has not passed
    this.#currentShipmentDate = dayjs().isBefore(monthAfterStartDate, 'day')
      ? this.startDate
      : this.lastInvoiceDate

    return this.#currentShipmentDate
  }
}
